import gql from "graphql-tag";

const GET_GENERAL_INFO_QUERY = gql`
  query Points($equipoID: Int!) {
    points(equipoID: $equipoID) {
      dir
      odo
      sOdo
      horo
      utx
      mid
    }
  }
`;

export default GET_GENERAL_INFO_QUERY;
